module.exports = __webpack_public_path__ + "static/media/teacher12.e2a90751.png";